type AccountIdentity = {
  is_business?: boolean;
  is_venue?: boolean;
  is_verified?: boolean;
};

export function isDirectBusinessAccount(account: unknown): boolean {
  if (!account || typeof account !== 'object') return false;
  const identity = account as AccountIdentity;
  return Boolean((identity.is_business || identity.is_venue) && identity.is_verified);
}
